import React from 'react';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user } = useAuth();

  return (
    <div className="bg-gray-800 p-4 flex items-center justify-between border-b border-gray-700">
      <h2 className="text-white font-semibold text-lg">
        Tableau de bord
      </h2>
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <span className="text-white text-sm font-bold">
            {user?.name?.charAt(0)}
          </span>
        </div>
        <div>
          <p className="text-white text-sm font-semibold">{user?.name}</p>
          <p className="text-gray-400 text-xs">{user?.role}</p>
        </div>
      </div>
    </div>
  );
};

export default Navbar;